import { isAxiosError, type AxiosRequestConfig } from "axios"
import { garconClient } from "@apis/axiosClients"

export const baseServiceRequest = async (request: AxiosRequestConfig) => {
  try {
    return await garconClient(request)
  } catch (error) {
    if (isAxiosError(error)) {
      console.error("API request error:", error)
    } else {
      console.error("Unknown error in BaseServiceRequest:", error)
    }
    throw error
  }
}
